import React from 'react';
import GenericAvmLeadScore from './GenericAvmLeadLeadScore';
import GenericAvmLeadOverlay from './GenericAvmLeadOverlay';

export default class GenericAvmLeadTable extends React.Component {
	render() {
		return (
			<section className="relative mb-20">
				<GenericAvmLeadScore />
				<div className="message-overlay">
					<GenericAvmLeadOverlay />
				</div>
			</section>
		);
	}
}
